import React from 'react'
import dayjs from 'dayjs'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Fact from '../Fact'

const formatExtra = (extra) =>
  extra && typeof extra === 'object' ? JSON.stringify(extra) : extra

// The registry shows this to iBoxen only. It has to be gated on its own data
// as well: an iBoxen user on a parcel with no feedback would get an empty card.
export default function Feedback({ parcel }) {
  const { t } = useTranslation('parcels')
  const { npsScore, feedbackText } = parcel.consumerFeedback || {}
  const { returnReason } = parcel
  const retentionUpdates = parcel.retentionUpdates || []

  if (!npsScore && !returnReason && retentionUpdates.length === 0) return null

  return (
    <Stack spacing={1}>
      {npsScore ? (
        <Fact label={t('feedback')}>
          {[npsScore, feedbackText].filter(Boolean).join(' – ')}
        </Fact>
      ) : null}
      {returnReason ? (
        <Fact label={t('returnReason')}>
          {[returnReason.code, formatExtra(returnReason.extra)]
            .filter(Boolean)
            .join(' – ')}
        </Fact>
      ) : null}
      {retentionUpdates.length > 0 ? (
        <Fact label={t('retentionUpdates')}>
          {retentionUpdates
            .map(
              ({ created, retention }) =>
                `${dayjs(created).format('DD/MM HH:mm')} ${retention}`
            )
            .join(', ')}
        </Fact>
      ) : null}
    </Stack>
  )
}
